import { addDays, format, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const IST = 'Asia/Kolkata';

function toIstDateKey(date: Date): string {
  return format(toZonedTime(date, IST), 'yyyy-MM-dd');
}

function formatIstPattern(dateKey: string, pattern: string): string {
  return format(toZonedTime(new Date(`${dateKey}T12:00:00`), IST), pattern);
}

/**
 * Convert JS `Date#getDay()` (Sun=0…Sat=6) to clinic schedule index
 * (Mon=0…Sun=6), matching settings UI and `clinic_schedules.day_of_week`.
 */
export function toWorkingHoursDayOfWeek(jsDay: number): number {
  return (jsDay + 6) % 7;
}

/** Calendar day key in Asia/Kolkata (`yyyy-MM-dd`). */
export function todayWorkingDayKey(now: Date = new Date()): string {
  return toIstDateKey(now);
}

export function tomorrowWorkingDayKey(now: Date = new Date()): string {
  const todayNoon = parseISO(`${todayWorkingDayKey(now)}T12:00:00`);
  return toIstDateKey(addDays(todayNoon, 1));
}

/**
 * Compact chip label for the working-day control.
 * Returns "Today · d MMM", "Tomorrow · d MMM", or a weekday short form.
 */
export function workingDayChipLabel(dateKey: string, now: Date = new Date()): string {
  const short = formatIstPattern(dateKey, 'd MMM');
  if (dateKey === todayWorkingDayKey(now)) return `Today · ${short}`;
  if (dateKey === tomorrowWorkingDayKey(now)) return `Tomorrow · ${short}`;
  return formatIstPattern(dateKey, 'EEE · d MMM');
}
